import React from 'react'
import { Loading, Popup } from 'src/components'
import { useStyles } from './styles'
import { ReproductiveCard } from '../../../../../components/ReproductiveCard'
import { useGetPregnancyDiagnosisListByAnimalId } from 'src/hooks/api/pregnancy-diagnosis'

interface ReproductiveHistoryModalProps {
  isOpen: boolean
  onClose: () => void
  animalId: string
}

export const ReproductiveHistoryModal: React.FC<ReproductiveHistoryModalProps> = ({ isOpen, onClose, animalId }) => {
  const style = useStyles()

  const {
    data: historyList = [],
    isLoading,
    isFetching,
    isError,
    refetch
  } = useGetPregnancyDiagnosisListByAnimalId(animalId)

  if (!isOpen) {
    return null
  }

  if (isLoading || isFetching || isError) {
    return (
      <Popup title='Histórico reprodutivo' className={style.historyPopup} onClose={onClose}>
        <div className={style.loadingContainer}>
          <Loading isError={isError} refetch={refetch} />
        </div>
      </Popup>
    )
  }

  return (
    <Popup title='Histórico reprodutivo' className={style.historyPopup} onClose={onClose}>
      <div className={style.historyList}>
        {historyList.map((historyItem) => (
          <ReproductiveCard key={historyItem.id} data={historyItem} />
        ))}
      </div>
    </Popup>
  )
}
